export const NOTIFY_SHOW_MESSAGE = 'NOTIFY_SHOW_MESSAGE'; // eslint-disable-line
